import { render, staticRenderFns } from "./Locations.vue?vue&type=template&id=2b5121cc&scoped=true&"
import script from "./Locations.vue?vue&type=script&lang=ts&"
export * from "./Locations.vue?vue&type=script&lang=ts&"
import style0 from "./Locations.vue?vue&type=style&index=0&id=2b5121cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5121cc",
  null
  
)

export default component.exports